/**
 * PlanetResourceLegend — floating legend panel (top-left of globe)
 * explaining the resource heatmap colours. Only visible when the
 * resource layer is active.
 */

import { usePlanetPanelStore } from './state/planetPanelStore';

export function PlanetResourceLegend() {
  const resourcesOn = usePlanetPanelStore((s) => s.layers.noise);
  const isBaking = usePlanetPanelStore((s) => s.isBakingTexture);

  if (!resourcesOn || isBaking) return null;

  return (
    <div style={panelStyle}>
      <div style={titleStyle}>Resource Map</div>
      <LegendRow color="#2ac850" label="Organic" />
      <LegendRow color="#3080dc" label="Crystal" />
      <div style={gradientRowStyle}>
        <span style={{ color: '#5a6a7a' }}>Sparse</span>
        <span style={gradientBarStyle} />
        <span style={{ color: '#f5e8d1' }}>Rich</span>
      </div>
      <div style={hintStyle}>Dark areas are depleted or empty</div>
    </div>
  );
}

function LegendRow({ color, label }: { color: string; label: string }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '3px 0' }}>
      <span style={{
        display: 'inline-block',
        width: 12,
        height: 12,
        borderRadius: 2,
        background: color,
        opacity: 0.9,
        flexShrink: 0,
      }} />
      <span style={{ color: '#c0d0dd' }}>{label}</span>
    </div>
  );
}

const panelStyle: React.CSSProperties = {
  position: 'absolute',
  top: 16,
  left: 16,
  padding: '10px 14px',
  background: 'rgba(15, 27, 38, 0.88)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: 6,
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: 11,
  zIndex: 10,
  pointerEvents: 'none',
  minWidth: 140,
};

const titleStyle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  color: '#20a5a6',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 6,
};

const gradientRowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  marginTop: 6,
  fontSize: 10,
};

const gradientBarStyle: React.CSSProperties = {
  flex: 1,
  height: 6,
  borderRadius: 3,
  background: 'linear-gradient(to right, rgba(255,255,255,0.05), rgba(100,210,140,0.7), rgba(50,180,220,0.7))',
};

const hintStyle: React.CSSProperties = {
  marginTop: 6,
  fontSize: 10,
  color: '#5a6a7a',
  fontStyle: 'italic',
};
